import { render, staticRenderFns } from "./HomeworkStatisHead.vue?vue&type=template&id=643d3984&scoped=true&"
import script from "./HomeworkStatisHead.vue?vue&type=script&lang=js&"
export * from "./HomeworkStatisHead.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkStatisHead.vue?vue&type=style&index=0&id=643d3984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d3984",
  null
  
)

export default component.exports